import React from "react";
var Image = function Image(_ref) {
  var src = _ref.src,
    alt = _ref.alt;
  return /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt,
    width: "110",
    height: "140"
  });
};
export default Image;